//Этот компонент выводит информацию об организации (должен опрокидываться props, в котором обязательно содержится data с name и  value (c типом  и цветом текста для value))
//Построен на флекс(name - левая сторона колонки, value - правая)
//Также принимает опционально title и style(для передачи кастомных стилей)!
//Нужно будет переделать interface - пока не готово апи с необходимыми ключами!

import React, { FC } from "react";
import classes from "./style/UI_ITOModuleInfo.module.css";
import { Form, Input, InputNumber } from "antd";
import { nanoid } from "nanoid";
import { formatter, parser } from "../../utils/utilities/InputSumFunctions";
import { validateDate } from "../../utils/utilities/ValidateDate";
import { UI_ITOModuleSubTitle } from "../indexUI";
import {
  ruleRequired,
  ruleSummMinMax,
} from "../../constants/rules/RulesConstantsForms";

interface UI_ModuleInfo {
  style?: React.CSSProperties;
  title?: React.ReactNode;
  data: {
    name: string;
    value: string;
    type?: { link: string; color: string };
    href?: string;
    label?: string;
  }[];
}
export const UI_ModuleInfo: FC<UI_ModuleInfo> = (props) => {
  const { style, title, data } = props;
  const currentDate = new Date().toISOString().split("T")[0];

  const GetTeg = ({
    type,
    children,
    href,
  }: {
    type: { link: string; color: string };
    children: React.ReactNode;
    href?: string;
  }) => {
    const styles: React.CSSProperties = { width: "100%" };
    if (type?.link === "link" && href) {
      return (
        <a style={styles} target="_blank" href={href} rel="noreferrer">
          {children}
        </a>
      );
    }

    if (children === "undefined") {
      return <></>;
    }

    return <div style={styles}>{children}</div>;
  };

  return (
    <div style={style} className={classes.cardWrapper}>
      <div className={classes.titleWrapper}>
        <UI_ITOModuleSubTitle title={`${title}`} />
      </div>
      {data?.map((item) => {
        const unikKey = nanoid();

        if (item?.type) {
          return (
            <div key={unikKey} className={classes.dataWrapper}>
              <div className={classes.key}>{item.name}</div>
              <div className={classes.value}>
                <GetTeg type={item.type} href={item.href}>
                  {item.value}
                </GetTeg>
              </div>
            </div>
          );
        } else if (title === "Начало и окончание БГ") {
          return (
            <Form.Item
              key={unikKey}
              label={item.label}
              name={item.name}
              rules={[
                ruleRequired,
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const fieldValue = getFieldValue(item.name);
                    const inputValue = new Date(value);

                    return validateDate({ fieldValue, inputValue });
                  },
                }),
              ]}
              className={classes.infoInput}
            >
              <Input type="date" style={{ width: "100%" }} min={currentDate} />
            </Form.Item>
          );
        } else {
          return (
            <Form.Item
              key={unikKey}
              label={item.label}
              name={item.name}
              rules={[ruleRequired, ruleSummMinMax]}
              className={classes.infoInput}
            >
              <InputNumber
                controls={false}
                style={{ width: "100%" }}
                formatter={formatter}
                parser={parser}
              />
            </Form.Item>
          );
        }
      })}
    </div>
  );
};
